import React, {useContext} from 'react';
import CustomerDataProvider, {customerDataContext} from '../contexts/CustomerDataProvider';
import {setPageTitle} from '../utils/helpers';
import withFeatureFlags from "../components/FeatureFlags/withFeatureFlags";
import FocusedForm from "../layouts/FocusedForm/FocusedForm";
import FisaAccountClosure from "../components/MyAccount/AccountClosure/FisaAccountClosure";
import InstantAccessCashIsaClosure from "../components/MyAccount/AccountClosure/DISA/InstantAccessCashIsaClosure";

/**
 * Inner component that has access to customer data context
 */
const CloseFisaAccountContent = () => {
    const customerDataContextValue = useContext(customerDataContext);
    const data = customerDataContextValue?.data;
    const loading = customerDataContextValue?.loading;
    const path = window.location.pathname.split('/');
    
    /**
     * Check if the account is within the cooling-off period
     * @param {Date | string | undefined} coolingOffEndDate
     * @returns {boolean}
     */
    const checkCoolingOffPeriod = (coolingOffEndDate) => {
        if (!coolingOffEndDate) {
            return false;
        }

        const currentDate = new Date();
        const endDate = new Date(coolingOffEndDate);
        return currentDate <= endDate;
    };

    // Don't render FocusedForm (which triggers analytics) until data is loaded
    if (loading || !data) {
        return (
            <div className="text__navy">
                <FisaAccountClosure/>
            </div>
        );
    }

    const accountIdFromUrl = path[path.length - 1];
    const foundAccount = data.customer?.accounts?.find(account => account.id === accountIdFromUrl);

    if (foundAccount?.product?.productType === 'INSTANT_ACCESS_CASH_ISA') {
        return (
            <FocusedForm className="disa-closure-page" pageAnalyticsName="Instant Access Cash ISA Account Closure">
                <div className="text__navy">
                    <InstantAccessCashIsaClosure />
                </div>
            </FocusedForm>
        );
    }

    // Determine analytics page name based on cooling-off status
    let analyticsPageName = "FISA Account Closure";
    
    if (data.customer && data.customer.accounts) {
        if (foundAccount && foundAccount.coolingOffEndDate) {
            const isInCoolingOff = checkCoolingOffPeriod(foundAccount.coolingOffEndDate);
            analyticsPageName = isInCoolingOff 
                ? "FISA Account Closure - Cooling Off" 
                : "FISA Account Closure - Early Closure";
        }
    }

    return (
        <FocusedForm pageAnalyticsName={analyticsPageName}>
            <div className="text__navy">
                <FisaAccountClosure/>
            </div>
        </FocusedForm>
    );
};

const CloseFisaAccountPageContainer = () => {
    setPageTitle('Close account | Investec Save');
    return (
        <CustomerDataProvider>
            <CloseFisaAccountContent />
        </CustomerDataProvider>
    );
};

export default withFeatureFlags(CloseFisaAccountPageContainer);
